import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CatalogProductService {
  base = `${environment.BASE_LA}/api/catalog-product`;

  constructor(public httpClient: HttpClient) {}

  getList(params: {
    page?: number; limit?: number; search?: string; category?: string; se?: number;
    sort?: string; order?: string;
    dateFrom?: string; dateTo?: string; shop?: number | string; period?: string;
    sector?: number | string; plan?: string;
  }) {
    let httpParams = new HttpParams();
    if (params.page) httpParams = httpParams.set('page', params.page.toString());
    if (params.limit) httpParams = httpParams.set('limit', params.limit.toString());
    if (params.search) httpParams = httpParams.set('search', params.search);
    if (params.category) httpParams = httpParams.set('category', params.category);
    if (params.se) httpParams = httpParams.set('se', params.se.toString());
    if (params.sort) httpParams = httpParams.set('sort', params.sort);
    if (params.order) httpParams = httpParams.set('order', params.order);
    if (params.dateFrom) httpParams = httpParams.set('dateFrom', params.dateFrom);
    if (params.dateTo) httpParams = httpParams.set('dateTo', params.dateTo);
    if (params.shop !== undefined && params.shop !== null && params.shop !== '') httpParams = httpParams.set('shop', params.shop.toString());
    if (params.period) httpParams = httpParams.set('period', params.period);
    if (params.sector !== undefined && params.sector !== null && params.sector !== '') httpParams = httpParams.set('sector', params.sector.toString());
    if (params.plan) httpParams = httpParams.set('plan', params.plan);

    return lastValueFrom(this.httpClient.get<any>(`${this.base}/list`, { params: httpParams }));
  }

  getByCode(code: string) {
    return lastValueFrom(this.httpClient.get<any>(`${this.base}/${code}`));
  }

  getInvoicesByProduct(code: string, params: { page?: number; limit?: number }) {
    let httpParams = new HttpParams();
    if (params.page) httpParams = httpParams.set('page', params.page.toString());
    if (params.limit) httpParams = httpParams.set('limit', params.limit.toString());

    return lastValueFrom(this.httpClient.get<any>(`${this.base}/${code}/invoices`, { params: httpParams }));
  }

  getByInvoice(invoiceCode: string) {
    return lastValueFrom(this.httpClient.get<any>(`${this.base}/by-invoice/${invoiceCode}`));
  }

  getByPerson(personCode: string, params: { page?: number; limit?: number }) {
    let httpParams = new HttpParams();
    if (params.page) httpParams = httpParams.set('page', params.page.toString());
    if (params.limit) httpParams = httpParams.set('limit', params.limit.toString());

    return lastValueFrom(this.httpClient.get<any>(`${this.base}/by-person/${personCode}`, { params: httpParams }));
  }

  createProduct(body: { code: string; name: string; brand?: string; category?: string; ean_upc?: string; material?: string; numero_material?: string; se?: number }) {
    return lastValueFrom(this.httpClient.post<any>(`${this.base}`, body));
  }

  updateProduct(code: string, body: { name?: string; brand?: string; category?: string; material?: string; numero_material?: string; se?: number }) {
    return lastValueFrom(this.httpClient.put<any>(`${this.base}/${code}`, body));
  }

  deleteProduct(code: string) {
    return lastValueFrom(this.httpClient.delete<any>(`${this.base}/${code}`));
  }

  getDashboardStats(period?: string) {
    let httpParams = new HttpParams();
    if (period) httpParams = httpParams.set('period', period);

    return lastValueFrom(this.httpClient.get<any>(`${this.base}/stats/dashboard`, { params: httpParams }));
  }

  getCategories() {
    return lastValueFrom(this.httpClient.get<any>(`${this.base}/categories`));
  }

  getSectors() {
    return lastValueFrom(this.httpClient.get<any>(`${this.base}/sectors`));
  }

  search(q: string) {
    let httpParams = new HttpParams().set('q', q);
    return lastValueFrom(this.httpClient.get<any>(`${this.base}/search`, { params: httpParams }));
  }

  getEnhancedStats(params: {
    period?: string; dateFrom?: string; dateTo?: string;
    shop?: number | string; productCode?: string; sector?: number | string;
    plan?: string;
  } = {}) {
    let httpParams = new HttpParams();
    if (params.period) httpParams = httpParams.set('period', params.period);
    if (params.dateFrom) httpParams = httpParams.set('dateFrom', params.dateFrom);
    if (params.dateTo) httpParams = httpParams.set('dateTo', params.dateTo);
    if (params.shop !== undefined && params.shop !== null && params.shop !== '') httpParams = httpParams.set('shop', params.shop.toString());
    if (params.productCode) httpParams = httpParams.set('productCode', params.productCode);
    if (params.sector !== undefined && params.sector !== null && params.sector !== '') httpParams = httpParams.set('sector', params.sector.toString());
    if (params.plan) httpParams = httpParams.set('plan', params.plan);
    return lastValueFrom(this.httpClient.get<any>(`${this.base}/stats/enhanced`, { params: httpParams }));
  }

  getShopsFilter() {
    return lastValueFrom(this.httpClient.get<any>(`${this.base}/shops`));
  }

  getPlansFilter() {
    return lastValueFrom(this.httpClient.get<any>(`${this.base}/plans`));
  }

  getPriceHistory(code: string, period?: string) {
    let httpParams = new HttpParams();
    if (period) httpParams = httpParams.set('period', period);
    return lastValueFrom(this.httpClient.get<any>(`${this.base}/${code}/price-history`, { params: httpParams }));
  }

  getProductStatsDetail(code: string) {
    return lastValueFrom(this.httpClient.get<any>(`${this.base}/${code}/stats-detail`));
  }

  getProductsByCustomer(personCode: string) {
    return lastValueFrom(this.httpClient.get<any>(`${this.base}/by-customer/${personCode}`));
  }
}
